import {
  ADD_USER_ADDRESS,
  UPDATE_USER_DATA,
  CHECK_FORM_USER,
  MISSING_FIELDS,
  GET_USER_DATA,
} from "../types/user.types";
import { deepClone } from "../../utils/utils";

const initialState = {
  address: {
    zip_code: "",
    city: "",
    street: "",
    street_number: "",
    additional_address: "",
    country: "",
    lat: "",
    long: "",
    active: false,
  },
  user: {
    cgu_checked: 0,
    email: "",
    firstName: "",
    gender: 0,
    lastName: "",
    phone: "",
    society: "",
  },
  displayMissingFields: false,
  paymentFormOk: false,
  clientFormOk: false,
};

const reducer = function orderReducer(state = initialState, action) {
  const newState = deepClone(state);
  switch (action.type) {
    case ADD_USER_ADDRESS:
      const address = action.response;
      const newAddress = updateAddress(address);
      newState.address = newAddress;
      return newState;
    case GET_USER_DATA:
      const { userAddress, userData } = action.response;
      const addressRecover = Object.keys(userAddress).length
        ? updateAddress(userAddress)
        : newState.address;
      const user = updateUserData(userData);
      newState.address = addressRecover;
      newState.user = user;
      return newState;
    case UPDATE_USER_DATA:
      const dtaUser = action.response;
      const updateUser = updateUserData(dtaUser);
      newState.user = updateUser;
      return newState;
    case MISSING_FIELDS:
      newState.displayMissingFields = !newState.displayMissingFields;
      return newState;
    case CHECK_FORM_USER:
      const { formState, formName } = action.payload;
      return updateFormClient(newState, formState, formName);
    default:
      return newState;
  }
};

export default reducer;

function updateAddress(updatedAddress) {
  let address = {};
  const arrDatas = Object.entries(updatedAddress);
  arrDatas.forEach((arr) => {
    let obj = { [arr[0]]: arr[1] };
    address = { ...obj, ...address };
  });
  address.active = true;
  return address;
}

function updateUserData(userData) {
  let user = {};
  const arrDatas = Object.entries(userData);

  arrDatas.forEach((arr) => {
    let obj = { [arr[0]]: arr[1] };
    user = { ...obj, ...user };
  });
  return user;
}

function updateFormClient(state, formState, formName) {
  state[formName] = formState;
  return state;
}
